import { Link } from "react-router-dom";
import { ArrowRight, Hexagon } from "lucide-react";

export function Overline({ children, className = "", light = false }) {
  return (
    <div className={`inline-flex items-center gap-2 text-base font-bold uppercase tracking-[0.2em] ${light ? "text-white" : "text-automex-teal"} ${className}`}>
      <Hexagon className="h-3.5 w-3.5 fill-automex-teal/25 text-automex-teal" aria-hidden="true" />
      <span className="h-px w-6 bg-automex-teal" aria-hidden="true" />
      {children}
    </div>
  );
}

export function SectionHeading({ overline, title, subtitle, light = false, align = "left", className = "" }) {
  const alignClass = align === "center" ? "text-center items-center mx-auto" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignClass} max-w-3xl gap-4 ${className}`}>
      {overline && <Overline light={light}>{overline}</Overline>}
      <h2 className={`font-heading font-bold uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl md:text-6xl ${light ? "text-white" : "text-automex-ink"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`text-base sm:text-lg leading-relaxed max-w-2xl ${light ? "text-slate-300" : "text-slate-600"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}

export function CTAButton({ to, children, variant = "teal", className = "", ...props }) {
  const styles = {
    teal: "bg-automex-teal text-automex-navy hover:bg-[#12b494]",
    blue: "bg-automex-blue text-white hover:bg-automex-navy",
    outline: "border border-white/40 text-white hover:bg-white hover:text-automex-navy",
    outlineDark: "border border-automex-blue/30 text-automex-blue hover:bg-automex-blue hover:text-white",
  };
  return (
    <Link
      to={to}
      className={`group inline-flex items-center gap-2.5 px-7 py-3.5 text-sm font-semibold uppercase tracking-wider rounded-sm transition-colors duration-300 ${styles[variant]} ${className}`}
      {...props}
    >
      {children}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    </Link>
  );
}
